import { render, staticRenderFns } from "./Biaoti.vue?vue&type=template&id=a912a292&"
import script from "./Biaoti.vue?vue&type=script&lang=js&"
export * from "./Biaoti.vue?vue&type=script&lang=js&"
import style0 from "./Biaoti.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports